import { Text } from '@slal/ui/typography';
import { RadioOption } from '@slal/ui/forms';
import { useApplicationContext } from '~/hooks';
import { LumpSumOptions } from '~/types';
import { formatToGBP } from '~/utils';
import { lumpSumOptions } from './utils';

export const useApplicationTaxFreeCashOptions = (): RadioOption[] => {
    const {
        pensionValues: { halfTaxFreeCash, maximumTaxFreeCash },
    } = useApplicationContext();

    return lumpSumOptions.map(({ label, value }) => ({
        label:
            value === LumpSumOptions.MAXIMUM_TAX_FREE_CASH ? (
                <>
                    {label} <Text tag="strong">{formatToGBP(maximumTaxFreeCash)}</Text>
                </>
            ) : value === LumpSumOptions.HALF_TAX_FREE_CASH ? (
                <>
                    {label} <Text tag="strong">{formatToGBP(halfTaxFreeCash)}</Text>
                </>
            ) : (
                label
            ),
        value,
    }));
};
